import PaymentMethods from './PaymentMethods';
import CreditCard from './components/CreditCard';
import paymentMethodConfig from './config/paymentTypes';
import paymentMethodsSlice from './paymentMethodsSlice';

export default PaymentMethods;
export {
  paymentMethodConfig,
  CreditCard,
  paymentMethodsSlice,
};
